import React, { useContext } from "react";
import MyContext from "../../MyContext";

const MembershipCard = () => {
  const {
    companyData,
    AppliedCouponData,
    totalDiscountAmt,
    totalPrice,
    InputValues,
    totalDiscountAmtWithoutDiscount,
    MembershipItems,
    AddMembershipToCart,
    isMembershipCardAdded,
    setMembershipItems,
    AutoApplyCoupon,
    // AutoApplyCouponType,
    // setAutoApplyCouponType,
    setIsMembershipCardAdded,
    setAutoApplyCoupon,
    setAllCouponsData,
    AllCouponsData,
    isMembershipDetails,
    setIsMembershipDetails,
    setLoading,
  } = useContext(MyContext);

  function formatDateWithFullMonth(yyyyMmDd) {
    if (!yyyyMmDd) return ""; // Handle null/undefined cases

    // Convert the input string to a Date object
    let date = new Date(yyyyMmDd);

    // Extract day, month, and year
    let day = date.getDate();
    let month = date.toLocaleString("en-US", { month: "long" }); // Get full month name (e.g., "January")
    let year = date.getFullYear();

    // Function to add ordinal suffix (st, nd, rd, th)
    function getDaySuffix(day) {
      if (day >= 11 && day <= 13) return "th"; // Special case for 11th, 12th, 13th
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    }

    // Return formatted date
    return `${day}${getDaySuffix(day)} ${month} ${year}`;
  }

  return (
    <>
      {isMembershipDetails != 0 ? (
        <div class="inner goldborder">
          <div class="top-white"></div>
          <div style={{ border: "0" ,    padding: "3px", }} className="pricebox-type-1">
            <div className="pricebox-heading Total-bold-pay">
              Your Membership Expiry Date Is :- <br />{" "}
              {formatDateWithFullMonth(isMembershipDetails.cardExpiryDate)}
            </div>
            <div
              className="pricebox-heading-2 Total-bold-pay"
              style={{ zIndex: "1" }}
            >
              <button
                style={{ width: "85px", lineHeight: "20px", zIndex: "1" }}
                onClick={() =>
                  AddMembershipToCart("", isMembershipDetails.itemId_d2)
                }
              >
                Extend Validity
              </button>
            </div>
          </div>
        </div>
      ) : (
        <>
          {AutoApplyCoupon.length != 0 && (
            <>
              {isMembershipCardAdded == false && (
                <>
                  {MembershipItems.length == AutoApplyCoupon.length && (
                    <>
                      {MembershipItems.map((item, index) => (
                        <div class="inner goldborder" onClick={() => AddMembershipToCart(item)} >
                          <div class="top-white"></div>
                          <div
                            // style={{
                            //   borderBottom:
                            //     index === MembershipItems.length - 1
                            //       ? "none"
                            //       : "1px dashed rgb(179, 179, 179)",
                            //       padding: "3px",
                            // }}
                            style={{borderBottom: "none"}}
                            className="pricebox-type-1"
                          >
                            <div className="pricebox-heading Total-bold-pay">
                              {AutoApplyCoupon[index].disType == "1" ? (
                                <>
                                  Add {item.printName} Membership and Get{" "}
                                  {AutoApplyCoupon[index].disVal || 0} % off
                                </>
                              ) : (
                                <>
                                  Add {item.printName} Membership and Get Flat{" "}
                                  {AutoApplyCoupon[index].disVal || 0}{" "}
                                  {companyData.currencySymbol} off
                                </>
                              )}
                            </div>
                            <div
                              className="pricebox-heading-2 Total-bold-pay"
                              style={{ zIndex: "1" }}
                            >
                              <button >
                                Add
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default MembershipCard;
